export const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
export const API_URL = process.env.REACT_APP_API_URL as string;
export const FRONTEND_URL = process.env.REACT_APP_FRONTEND_URL as string;
export const DEFAULT_PAGE_SIZE = 10;
